export const vapidPublicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY ?? '';
